import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { withUserAccess } from '../../withUserAccess';

import List from './VehicleList/List';
import Form from './VehicleList/Form';
import Card from './VehicleList/Card';

import MeasuringDeviceCertifications from './Budget/MeasuringDeviceCertifications';
import LicensePlateChange from './Budget/LicensePlateChange';
import DriverInspection from './Budget/DriverInspection';
import InspectionsGibdd from './Budget/InspectionsGibdd';
import InspectionsGtn from './Budget/InspectionsGtn';
import GpmMaintenance from './Budget/GpmMaintenance';
import FederalHighway from './Budget/FederalHighway';
import Battaries from './Budget/Batteries';
import Material from './Budget/Material';
import Washing from './Budget/Washing';
import Gps from './Budget/Gps';
import SpringPass from './Budget/SpringPass';
import CargoPass from './Budget/CargoPass';
import Maintenance from './OperationBudget/Maintenance';
import Tire from './OperationBudget/Tire';
import FuelsAndOils from './OperationBudget/FuelsAndOils/List';
import Mechanisms from './OperationBudget/Mechanisms/List';

import OverhaulRepair from './Repair/OverhaulRepair/Card';
import CurrentRepair from './Repair/CurrentRepair/Card';
import BudgetRepair from './Repair/BudgetRepair/Card';

import Additional from './Additional/List';

import BudgetItogList from './BudgetItog/List';
import { RouteComponent } from '../../../lib/routerAdapter';

export default withUserAccess(({ userAccess }) => {
  return (
    <>
      <Routes>
        <Route path="new" element={<RouteComponent component={Form} />} />
        <Route index element={<RouteComponent component={List} />} />
        <Route path=":vehiclePlanId/card" element={<RouteComponent component={Card} />} />
        <Route path=":vehiclePlanId/card/:type" element={<RouteComponent component={Form} />} />

        <Route path=":vehiclePlanId/measuring-device-certifications" element={<RouteComponent component={MeasuringDeviceCertifications} />} />
        <Route path=":vehiclePlanId/license-plate-change" element={<RouteComponent component={LicensePlateChange} />} />
        <Route path=":vehiclePlanId/driver-inspection" element={<RouteComponent component={DriverInspection} />} />
        <Route path=":vehiclePlanId/inspections-gibdd" element={<RouteComponent component={InspectionsGibdd} />} />
        <Route path=":vehiclePlanId/gpm-maintenance" element={<RouteComponent component={GpmMaintenance} />} />
        <Route path=":vehiclePlanId/inspections-gtn" element={<RouteComponent component={InspectionsGtn} />} />
        <Route path=":vehiclePlanId/federal-highway" element={<RouteComponent component={FederalHighway} />} />
        <Route path=":vehiclePlanId/batteries" element={<RouteComponent component={Battaries} />} />
        <Route path=":vehiclePlanId/material" element={<RouteComponent component={Material} />} />
        <Route path=":vehiclePlanId/washing" element={<RouteComponent component={Washing} />} />
        <Route path=":vehiclePlanId/gps" element={<RouteComponent component={Gps} />} />

        <Route path=":vehiclePlanId/spring-pass" element={<RouteComponent component={SpringPass} />} />
        <Route path=":vehiclePlanId/cargo-pass" element={<RouteComponent component={CargoPass} />} />

        <Route path=":vehiclePlanId/overhaul-repair" element={<RouteComponent component={OverhaulRepair} />} />
        <Route path=":vehiclePlanId/current-repair" element={<RouteComponent component={CurrentRepair} />} />
        <Route path=":vehiclePlanId/budget-repair" element={<RouteComponent component={BudgetRepair} />} />

        <Route path=":vehiclePlanId/fuels-and-oils" element={<RouteComponent component={FuelsAndOils} />} />
        <Route path=":vehiclePlanId/mechanisms" element={<RouteComponent component={Mechanisms} />} />
        <Route path=":vehiclePlanId/tire" element={<RouteComponent component={Tire} />} />
        <Route path=":vehiclePlanId/maintenance" element={<RouteComponent component={Maintenance} />} />

        <Route path=":vehiclePlanId/additional" element={<RouteComponent component={Additional} />} />

        <Route path=":vehiclePlanId/itog" element={<RouteComponent component={BudgetItogList} />} />
      </Routes>
    </>
  );
});
